import axios from "axios";

const postClinic = async (baseUrl, token, doctorId, clinicBody) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let postResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/clinic", clinicBody, config)
        .then((res) => {
            postResponse = {
                status: res.data.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                postResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return postResponse
}

export default postClinic;